module.exports = __webpack_public_path__ + "img/NKCLC-logo.0d3c3d80.png";